const RAISE_NAMES = { 1: 'um', 3: 'truco', 6: 'seis', 9: 'nove', 12: 'doze' }

function raiseName(value) {
  return RAISE_NAMES[value] || String(value)
}

export default function ActionButtons({ actions, handValue, onRaise, onSurrender, onStartHand }) {
  const buttons = []

  if (actions.includes('raise')) {
    const nextRaise = { 1: 3, 3: 6, 6: 9, 9: 12 }[handValue] || 12
    buttons.push(
      <button
        key="raise"
        type="button"
        className="btn btn-primary btn-large"
        aria-label={`Pedir ${raiseName(nextRaise)}`}
        onClick={onRaise}
      >
        Pedir {raiseName(nextRaise)}
      </button>
    )
  }

  if (actions.includes('surrender')) {
    buttons.push(
      <button
        key="surrender"
        type="button"
        className="btn btn-danger btn-large"
        aria-label="Desistir da mão atual"
        onClick={onSurrender}
      >
        Desistir da mão
      </button>
    )
  }

  if (actions.includes('start_hand') || actions.includes('next_hand')) {
    buttons.push(
      <button
        key="start-hand"
        type="button"
        className="btn btn-primary btn-large"
        onClick={onStartHand}
      >
        Iniciar mão
      </button>
    )
  }

  return <div id="action-buttons" className="action-buttons">{buttons}</div>
}
